import React, { FC, useState } from "react";
import {
  RelatedItemsCategoriesModel,
  RelatedItemsPriceCategoriesModel,
  ProductAttributeInputModel,
  PurchaseCheckOutAddOnDetails,
  RelatedSectionModel,
} from "../../shared/models";
import { observer } from "mobx-react";
import {
  CustomButton,
  CustomLabel,
  CustomWidth,
  FlexContainer,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { ICheckOutCombinedColors, INavItem } from "../../shared/interfaces";
import { ItemDetailsCard } from "../../shared/styles";
import {
  ItemNotAvailableWarning,
  NavPills,
  PurchasePriceDescriptionRow,
} from "../../shared/components";
import { sanitizeHtml } from "../../shared/utils/sanitizeHtml";

type IProps = {
  itemName: string;
  requiredItems?: RelatedItemsCategoriesModel[] | null;
  recommendedItems?: RelatedItemsCategoriesModel[] | null;
  relatedItems?: RelatedSectionModel | null;
  addOns: PurchaseCheckOutAddOnDetails[];
  updateAddOns: (addOns: RelatedItemsPriceCategoriesModel[]) => void;
  colors: ICheckOutCombinedColors | null | undefined;
};

const PurchaseAddOn: FC<IProps> = ({
  itemName,
  requiredItems,
  recommendedItems,
  addOns,
  updateAddOns,
  colors,
  relatedItems,
}) => {
  const defaultActivePill = requiredItems?.length ? "required" : "recommended";
  const showNavPills =
    requiredItems &&
    requiredItems?.length > 0 &&
    recommendedItems &&
    recommendedItems?.length > 0;
  const [activePill, setActivePill] = useState(defaultActivePill);

  const navPills = (): INavItem[] => {
    return [
      {
        key: "required",
        title: "REQUIRED",
      },
      {
        key: "recommended",
        title: "RECOMMENDED",
      },
    ];
  };

  function onAddOnItemSelection(
    relatedItem: RelatedItemsCategoriesModel,
    selectedPrice: RelatedItemsPriceCategoriesModel,
    isSelected: boolean,
    isRequiredItem: boolean,
  ) {
    //id here is price id
    const index = addOns?.findIndex((f) => f.id === selectedPrice.id);

    const clonedAddOns =
      addOns?.map((a) => new PurchaseCheckOutAddOnDetails(a)) || [];
    if (isSelected) {
      if (index === -1) {
        let selectedVariantId = "";
        let onlyAllowedVariantIds: string[] = [];
        if (relatedItem.hasVariants) {
          if (isRequiredItem) {
            const validRequiredVariants =
              relatedItem.getValidRequiredVariantOptions();
            selectedVariantId =
              validRequiredVariants.length > 0
                ? validRequiredVariants[0].id
                : "";
            onlyAllowedVariantIds = relatedItem.requiredVariantIds;
          } else {
            const validRecommendedVariants =
              relatedItem.getValidRecommendedVariantOptions();
            selectedVariantId =
              validRecommendedVariants.length > 0
                ? validRecommendedVariants[0].id
                : "";
            onlyAllowedVariantIds = relatedItem.recommendedVariantIds;
          }
        }
        const quantity = isRequiredItem
          ? relatedItem.requiredQuantity
          : relatedItem.recommendedQuantity;
        const newSelectedAddOn = new PurchaseCheckOutAddOnDetails({
          ...selectedPrice,
          itemId: relatedItem.id,
          itemType: relatedItem.type,
          //FOR NOW SET SELECTED VARIANT AS EMPTY AS PER REQUIREMENT USER HAVE TO CHOOSE ON OPTIONS PAGE
          variantId: "", // selectedVariantId,
          selectedVariant: selectedVariantId ? relatedItem.variants : undefined,
          hasVariants: relatedItem.hasVariants,
          onlyAllowedVariantIds: onlyAllowedVariantIds,
          name: relatedItem.name,
          description: relatedItem.description,
          descriptionEditorState: relatedItem.descriptionEditorState,
          media: relatedItem.medias,
          descriptionEditorRawContent: relatedItem.descriptionEditorRawContent,
          isTrackInventory: relatedItem.isTrackInventory,
          quantity: quantity || 1,
          hasSurcharge: relatedItem.surcharge,
          tax: relatedItem.tax,
          return: relatedItem.return,
          returnDays: relatedItem.returnDays,
          discount: relatedItem.discount,
        });
        clonedAddOns.push(newSelectedAddOn);
      }
    } else {
      if (index !== -1) {
        clonedAddOns.splice(index, 1);
      }
    }
    updateAddOns(clonedAddOns);
  }

  function isSelected(
    item: RelatedItemsPriceCategoriesModel,
    variantIds?: string[],
  ) {
    const isMatchedByPrice = addOns?.findIndex((f) => f.id === item.id) !== -1;
    const isMatchedByAddOnId =
      addOns?.find((f) => variantIds?.indexOf(f.variantId) !== -1) !==
      undefined;
    return isMatchedByPrice || isMatchedByAddOnId;
  }

  const renderItems = (
    isRequired: boolean,
    items?: RelatedItemsCategoriesModel[] | null,
  ) => {
    if (!items) return null;
    return (
      <>
        {items &&
          items.map((item) => {
            return item?.prices?.map((price, idx) => {
              const isItemSelected = isSelected(price, item.requiredVariantIds);

              const requiredVariantIds = item.requiredVariantIds ?? [];
              const recommendedVariantIds = item.recommendedVariantIds ?? [];

              const medias = item.getAllMedias(
                isRequired ? requiredVariantIds : recommendedVariantIds,
                true,
              );
              const media = medias?.find((x) => x?.isImage())?.fullURL;

              const variants = item.variants;

              // const isSelectedInRequired =
              //     item.requiredVariantIds?.find(
              //         (f) => addOns.find((a) => a.variantId === f) !== undefined,
              //     ) !== undefined;

              return (
                <div key={idx}>
                  <ItemDetailsCard>
                    <FlexContainer spacing={30}>
                      <CustomWidth>
                        {renderPriceBox(item, price, variants)}
                        <FlexContainer
                          alignItems="center"
                          spacing={15}
                          className="btns-div"
                        >
                          {isItemSelected ? (
                            <>
                              <CustomButton
                                bgColor={colors?.primary?.rgba || "#F2F1FF"}
                                borderColor={colors?.primary?.rgba || "#6C69CA"}
                                // color={colors?.primary?.rgba || '#6C69CA'}
                                color="#fff"
                                borderRadius={"4px !important"}

                                //className="sapphire-solid"
                              >
                                Added
                              </CustomButton>
                              <CustomButton
                                bgColor={colors?.primary?.rgba || "transparent"}
                                color={colors?.primary?.rgba || "#6C69CA"}
                                className="btn-without-border"
                                onClick={() =>
                                  onAddOnItemSelection(
                                    item,
                                    price,
                                    false,
                                    isRequired,
                                  )
                                }
                              >
                                Remove
                              </CustomButton>
                            </>
                          ) : (
                            <CustomButton
                              bgColor={colors?.primary?.rgba || "#F2F1FF"}
                              borderColor={colors?.primary?.rgba || "#6C69CA"}
                              // color={colors?.primary?.rgba || '#6C69CA'}
                              color="#fff"
                              borderRadius={"4px !important"}
                              disabled={item.isItemUnavailable}
                              onClick={() =>
                                !item.isItemUnavailable &&
                                onAddOnItemSelection(
                                  item,
                                  price,
                                  true,
                                  isRequired,
                                )
                              }
                            >
                              Add
                            </CustomButton>
                          )}
                        </FlexContainer>
                        {item.isItemUnavailable && <ItemNotAvailableWarning />}
                      </CustomWidth>
                      <CustomWidth className="text-right add-on-image-container">
                        {media && (
                          <div className="add-on-image">
                            <img src={media} alt="product" />
                          </div>
                        )}
                      </CustomWidth>
                    </FlexContainer>
                  </ItemDetailsCard>
                </div>
              );
            });
          })}
      </>
    );
  };

  function renderItemsByActivePill() {
    switch (activePill) {
      case "required":
        return renderItems(true, requiredItems);
      case "recommended":
        return renderItems(false, recommendedItems);
      default:
        return null;
    }
  }

  function renderPriceBox(
    item: RelatedItemsCategoriesModel,
    price: RelatedItemsPriceCategoriesModel,
    variants: ProductAttributeInputModel,
    variantIndex?: number,
  ) {
    return (
      <FlexContainer
        fxLayout="column"
        className="item-description"
        spacing={10}
      >
        <CustomLabel> {item.name}</CustomLabel>
        {item.description !== "" && (
          <CustomLabel
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(UtilityMethods.getDraftJsEditorHtml(
                item.descriptionEditorState,
              )),
            }}
          ></CustomLabel>
        )}
        {/* <CustomLabel>
                <span>${item.priceDisplay}</span> / Month
            </CustomLabel> */}
        <PurchasePriceDescriptionRow
          billingType={price.billingType}
          terms={price.terms}
          priceId={price.id}
          recurrence={price.recurrence}
          itemType={item.type}
          hasVariants={item.hasVariants}
          variants={variants}
          quantity={1}
          variantIndex={variantIndex}
          className={`price-add-on ${item.description !== "" ? "" : "price-addon-wo-desc"}`}
        />
      </FlexContainer>
    );
  }

  const isCenteredRequiredItems = requiredItems?.length === 1;
  const isCenteredRecommendedItems = recommendedItems?.length === 1;
  return (
    <>
      {showNavPills && (
        <NavPills
          defaultActiveKey={activePill}
          pills={navPills()}
          onSelect={(key) => setActivePill(key)}
        />
      )}

      <FlexContainer fxLayout="column">
        <CustomLabel
          // padding="20px 0px"
          textAlign="center"
          className="full-width add-on-title"
        >
          As part of the <span className="font-bold"> {itemName} </span>
          we{" "}
          <span className="text-slate-blue semi-bold">
            {" "}
            {activePill === "required" ? "require" : "recommend"} the
            purchase{" "}
          </span>{" "}
          of{" "}
          {activePill === "required"
            ? UtilityMethods.numberToWord(
                relatedItems?.requiredItems.totalRequired || 1,
              ).toLowerCase()
            : "one"}{" "}
          of these items
        </CustomLabel>
        <div className="addon-body-scroll">
          <FlexContainer
            fxWrap="wrap"
            spacing={30}
            className="add-on-body"
            justifyContent={
              activePill === "required"
                ? isCenteredRequiredItems
                  ? "center"
                  : "flex-start"
                : isCenteredRecommendedItems
                  ? "center"
                  : "flex-start"
            }
          >
            {/* {purchaseStore.addOnSectionData.activePill === 'required'
                                ? purchaseStore.addOnSectionData.requiredProducts.map((product) => renderItems(product))
                                : purchaseStore.addOnSectionData.recommendedProducts.map((product) =>
                                      renderItems(product),
                                  )} */}

            {renderItemsByActivePill()}
          </FlexContainer>
        </div>
      </FlexContainer>
    </>
  );
};

export default withRouter(observer(PurchaseAddOn));
